import { Amplify, API, Auth } from 'aws-amplify';


export const getDataApi = async (callback) =>
{
    // callback(data)

    const apiName = 'typeform';
    const path = '/typeform';
    const myInit = {
    headers: {}, // OPTIONAL
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    };

    API.get(apiName, path, myInit)
    .then((response) => {
        callback(response.data)
    })
    .catch((error) => {
        console.log(error);
        callback({'status' : 'ERROR'})
    });
}

export const recordLoginApi = async (time) =>
{
    const apiName = 'usermanagement';
    const path = '/usermanagement';

    const body = {
        cmd : "recordLogin",
        data : {time : time}
    }

    Auth.currentUserInfo().then((user) => {
        const userId = user.attributes.sub

        if (userId)
        {
            const myInit = {
                response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
                queryStringParameters: {
                    userId: userId // OPTIONAL
                  },
                body: body, // replace this with attributes you need
              };
    
            API.post(apiName, path, myInit)
            .then((response) => {
                console.log('recorded')
                // callback(response.data)
            })
            .catch((error) => {
                console.log(error);
                // callback({'status' : 'ERROR'})
            });
        }
    })
}

export const getAllUserDataApi = async (callback) =>
{
    // console.log('test')
    // callback(data)

    const apiName = 'usermanagement';
    const path = '/usermanagement';
    // const myInit = {
    // headers: {}, // OPTIONAL
    // response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    // };

    Auth.currentUserInfo().then((user) => {
        // const userId = user.attributes.sub

        const myInit = {
            headers: {}, // OPTIONAL
            response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
            queryStringParameters: {
              }
        };
        
        API.get(apiName, path, myInit)
        .then((response) => {
            callback(response.data)
        })
        .catch((error) => {
            console.log(error);
            callback({'status' : 'ERROR'})
        });
        
        
    });
}

export const getUserDataApi = async (callback) =>
{
    // callback(data)

    const apiName = 'usermanagement';
    const path = '/usermanagement';
    // const myInit = {
    // headers: {}, // OPTIONAL
    // response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    // };

    Auth.currentUserInfo().then((user) => {
        const userId = user.attributes.sub

        const myInit = {
            headers: {}, // OPTIONAL
            response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
            queryStringParameters: {
                userId: userId // OPTIONAL
              }
        };
        
        API.get(apiName, path, myInit)
        .then((response) => {
            callback(response.data)
        })
        .catch((error) => {
            console.log(error);
            callback({'status' : 'ERROR'})
        });
        
        
    });

    
}

export const setIncomeGoalsApi = async (data, callback) =>
{
    const apiName = 'usermanagement';
    const path = '/usermanagement';

    const body = {
        cmd : "setIncomeGoals",
        data : data
    }

    

    Auth.currentUserInfo().then((user) => {
        const userId = user.attributes.sub

        const myInit = {
            response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
            queryStringParameters: {
                userId: userId // OPTIONAL
              },
            body: body, // replace this with attributes you need
          };

        API.post(apiName, path, myInit)
        .then((response) => {
            callback(response.data)
        })
        .catch((error) => {
            console.log(error);
            callback({'status' : 'ERROR'})
        });
    })

}

export const addUserApi = async (data, callback) => {
    const apiName = 'usermanagement';
    const path = '/usermanagement';

    const body = {
        cmd : "addUser",
        data : data
    }

    const myInit = {
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        body: body, // replace this with attributes you need
        };

    API.post(apiName, path, myInit)
    .then((response) => {
        callback(response.data)
    })
    .catch((error) => {
        console.log(error);
        callback({'status' : 'ERROR'})
    });
}

export const removeUserApi = async (userId, callback) => {
    const apiName = 'usermanagement';
    const path = '/usermanagement';

    const body = {
        cmd : "removeUser",
        data : null
    }

    const myInit = {
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        body: body, // replace this with attributes you need
        queryStringParameters: {
            userId: userId
            // userId: 'bdc91470-8e7b-49de-875c-b7f3ce91593b' // OPTIONAL
        }
    };

    API.del(apiName, path, myInit)
    .then((response) => {
        callback({'status' : 'SUCCESS'})
    })
    .catch((error) => {
        console.log(error);
        callback({'status' : 'ERROR'})
    });
}

export const getGoalsApi = async (callback) =>
{
    callback(goals)
}

const goals = {
    opens : 4,
    cois : 1,
    contacts : 10,
    intros : 4,
    total : 40
}


// const data = {
//     "normal": [
//         {
//             "First name": "Carole",
//             "How many new contacts did you have this week?": 5,
//             "What can we help you with this week?": "N/A",
//             "Last name": "Dixon",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1689033600000,
//             "email": "carole.dixon@fhfg.com",
//             "sum": 20
//         },
//         {
//             "First name": "Mickey",
//             "How many new contacts did you have this week?": 7,
//             "What can we help you with this week?": "n/a",
//             "Last name": "Wagner",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1688860800000,
//             "email": "mickey.wagner@fhfg.com",
//             "sum": 22
//         },
//         {
//             "First name": "Derrick",
//             "How many new contacts did you have this week?": 16,
//             "What can we help you with this week?": "N/A",
//             "Last name": "Walters",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 0,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1688860800000,
//             "email": "Derrick.walters@fhfg.com",
//             "sum": 15
//         },
//         {
//             "First name": "George",
//             "How many new contacts did you have this week?": 4,
//             "What can we help you with this week?": "N/A",
//             "Last name": "Adams",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 0,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1688688000000,
//             "email": "george.adams@fhfg.com",
//             "sum": 4
//         },
//         {
//             "First name": "Evan",
//             "How many new contacts did you have this week?": 8,
//             "What can we help you with this week?": "Setting up live workshops/seminars. I have a friend who is lending me the clubhouse for free in his apartment complex in Whitestone. Planning for mid July but need to know more about resources, compliance, etc.",
//             "Last name": "Khan",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 4,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1688688000000,
//             "email": "evan.khan@fhfg.com",
//             "sum": 38
//         },
//         {
//             "First name": "Max",
//             "How many new contacts did you have this week?": 12,
//             "What can we help you with this week?": "N/A",
//             "Last name": "McKinney",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 5,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1688083200000,
//             "email": "max.mckinney@fhfg.com",
//             "sum": 45
//         },
//         {
//             "First name": "Alicia",
//             "How many new contacts did you have this week?": 25,
//             "What can we help you with this week?": "N/A",
//             "Last name": "DSouza",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1688083200000,
//             "email": "alicia.dsouza@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "Derrick",
//             "How many new contacts did you have this week?": 12,
//             "What can we help you with this week?": "None",
//             "Last name": "Walters",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 0,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1687824000000,
//             "email": "derrick.walters@fhfg.com",
//             "sum": 15
//         },
//         {
//             "First name": "George",
//             "How many new contacts did you have this week?": 4,
//             "What can we help you with this week?": "N/A",
//             "Last name": "Adams",
//             "How many introductions did you receive this week?": 1,
//             "How many case opens did you have this week?": 1,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1687737600000,
//             "email": "george.adams@fhfg.com",
//             "sum": 14
//         },
//         {
//             "First name": "Suzanne",
//             "How many new contacts did you have this week?": 3,
//             "What can we help you with this week?": "Organization",
//             "Last name": "Schulze",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1687737600000,
//             "email": "suzanne.schulze@fhfg.com",
//             "sum": 23
//         },
//         {
//             "First name": "Max",
//             "How many new contacts did you have this week?": 9,
//             "What can we help you with this week?": "N/A",
//             "Last name": "McKinney",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 5,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1687737600000,
//             "email": "max.mckinney@fhfg.com",
//             "sum": 44
//         },
//         {
//             "First name": "Carole",
//             "How many new contacts did you have this week?": 7,
//             "What can we help you with this week?": "Preparing for my first-ever seminar on Friday!!!",
//             "Last name": "Dixon",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1687219200000,
//             "email": "carole.dixon@fhfg.com",
//             "sum": 32
//         },
//         {
//             "First name": "Mickey",
//             "How many new contacts did you have this week?": 11,
//             "What can we help you with this week?": "This week was mostly Passover, and I had a few cancellations. I'll work on filling up the other weeks of the year with activity",
//             "Last name": "Wagner",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1687132800000,
//             "email": "mickey.wagner@fhfg.com",
//             "sum": 25
//         },
//         {
//             "First name": "George",
//             "How many new contacts did you have this week?": 6,
//             "What can we help you with this week?": "N/A",
//             "Last name": "Adams",
//             "How many introductions did you receive this week?": 1,
//             "How many case opens did you have this week?": 0,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1686873600000,
//             "email": "george.adams@fhfg.com",
//             "sum": 11
//         },
//         {
//             "First name": "Max",
//             "How many new contacts did you have this week?": 13,
//             "What can we help you with this week?": "N/A",
//             "Last name": "McKinney",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 6,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1686873600000,
//             "email": "max.mckinney@fhfg.com",
//             "sum": 45
//         },
//         {
//             "First name": "Carole",
//             "How many new contacts did you have this week?": 7,
//             "What can we help you with this week?": "Creating goal focused lists. Same script strategy.",
//             "Last name": "Dixon",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1686614400000,
//             "email": "caroledixon1@gmail.com",
//             "sum": 27
//         },
//         {
//             "First name": "Suzanne",
//             "How many new contacts did you have this week?": 2,
//             "What can we help you with this week?": "N/A",
//             "Last name": "Schulze",
//             "How many introductions did you receive this week?": 1,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1686528000000,
//             "email": "suzanne.schulze@fhfg.com",
//             "sum": 17
//         },
//         {
//             "First name": "Mickey",
//             "How many new contacts did you have this week?": 21,
//             "What can we help you with this week?": "Will be away till the 16th",
//             "Last name": "Wagner",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1686441600000,
//             "email": "mickey.wagner@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "George",
//             "How many new contacts did you have this week?": 4,
//             "What can we help you with this week?": "N/A",
//             "Last name": "Adams",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 1,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1686268800000,
//             "email": "george.adams@fhfg.com",
//             "sum": 14
//         },
//         {
//             "First name": "Suzanne",
//             "How many new contacts did you have this week?": 5,
//             "What can we help you with this week?": "Script review - I set this up with Bovi",
//             "Last name": "Schulze",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1685923200000,
//             "email": "suzanne.schulze@fhfg.com",
//             "sum": 25
//         },
//         {
//             "First name": "Carole",
//             "How many new contacts did you have this week?": 8,
//             "What can we help you with this week?": "Language and prospecting",
//             "Last name": "Dixon ",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1685836800000,
//             "email": "carole.dixon@fhfg.com",
//             "sum": 28
//         },
//         {
//             "First name": "Mickey",
//             "How many new contacts did you have this week?": 11,
//             "What can we help you with this week?": "Na",
//             "Last name": "Wagner",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 4,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1685664000000,
//             "email": "mickey.wagner@fhfg.com",
//             "sum": 40
//         },
//         {
//             "First name": "George",
//             "How many new contacts did you have this week?": 5,
//             "What can we help you with this week?": "Objection handling.",
//             "Last name": "Adams",
//             "How many introductions did you receive this week?": 1,
//             "How many case opens did you have this week?": 0,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1685577600000,
//             "email": "george.adams@fhfg.com",
//             "sum": 10
//         },
//         {
//             "First name": "Suzanne",
//             "How many new contacts did you have this week?": 5,
//             "What can we help you with this week?": "You guys are doing everything. Now, it's up to me",
//             "Last name": "Schulze",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 4,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1685404800000,
//             "email": "suzanne.schulze@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "Carole",
//             "How many new contacts did you have this week?": 10,
//             "What can we help you with this week?": "Converting LinkedIn connections to open talks",
//             "Last name": "Dixon",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1685404800000,
//             "email": "carole.dixon@fhfg.com",
//             "sum": 25
//         },
//         {
//             "First name": "George",
//             "How many new contacts did you have this week?": 7,
//             "What can we help you with this week?": "How to use Marketing Suite to make event flyers & other related event planning content",
//             "Last name": "Adams",
//             "How many introductions did you receive this week?": 1,
//             "How many case opens did you have this week?": 1,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1685232000000,
//             "email": "george.adams@fhfg.com",
//             "sum": 17
//         },
//         {
//             "First name": "Mickey",
//             "How many new contacts did you have this week?": 12,
//             "What can we help you with this week?": "Need help with Smart Office",
//             "Last name": "Wagner",
//             "How many introductions did you receive this week?": 6,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1685059200000,
//             "email": "mickey.wagner@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "Max ",
//             "How many new contacts did you have this week?": 12,
//             "What can we help you with this week?": "N/A",
//             "Last name": "McKinney",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 4,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1685059200000,
//             "email": "max.mckinney@fhfg.com",
//             "sum": 35
//         },
//         {
//             "First name": "Max ",
//             "How many new contacts did you have this week?": 9,
//             "What can we help you with this week?": "Prepping for a FLO presentation",
//             "Last name": "McKinney",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 6,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1684713600000,
//             "email": "max.mckinney@fhfg.com",
//             "sum": 44
//         },
//         {
//             "First name": "Carole",
//             "How many new contacts did you have this week?": 9,
//             "What can we help you with this week?": "Encouragement",
//             "Last name": "Dixon",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 4,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1684713600000,
//             "email": "carole.dixon@fhfg.com",
//             "sum": 39
//         },
//         {
//             "First name": "Mickey",
//             "How many new contacts did you have this week?": 8,
//             "What can we help you with this week?": "Objection handling",
//             "Last name": "Wagner",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1684540800000,
//             "email": "mickey.wagner@fhfg.com",
//             "sum": 28
//         },
//         {
//             "First name": "Pablo ",
//             "How many new contacts did you have this week?": 7,
//             "What can we help you with this week?": "N/A",
//             "Last name": "Idrovo",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1684454400000,
//             "email": "pablo.idrovo@fhfg.com",
//             "sum": 27
//         },
//         {
//             "First name": "George",
//             "How many new contacts did you have this week?": 3,
//             "What can we help you with this week?": "I will be away this week.",
//             "Last name": "Adams",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1684454400000,
//             "email": "georgeadams@fhfg.com",
//             "sum": 23
//         },
//         {
//             "First name": "Suzanne",
//             "How many new contacts did you have this week?": 2,
//             "What can we help you with this week?": "Better language.",
//             "Last name": "Schulze",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1684108800000,
//             "email": "suzanne.schulze@fhfg.com",
//             "sum": 17
//         },
//         {
//             "First name": "Carole ",
//             "How many new contacts did you have this week?": 5,
//             "What can we help you with this week?": "N/A",
//             "Last name": "Dixon",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 4,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1684108800000,
//             "email": "carole.dixon@fhfg.com",
//             "sum": 35
//         },
//         {
//             "First name": "Mickey",
//             "How many new contacts did you have this week?": 6,
//             "What can we help you with this week?": "Creative ideas on how to sell the first meeting that produces a real call to action.",
//             "Last name": "Wagner",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1684022400000,
//             "email": "mickey.wagner@fhfg.com",
//             "sum": 31
//         },
//         {
//             "First name": "Elisheva",
//             "How many new contacts did you have this week?": 2,
//             "What can we help you with this week?": "How to move from meeting at a networking event, to coffee, to an open?",
//             "Last name": "Hay",
//             "How many introductions did you receive this week?": 1,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1684022400000,
//             "email": "elisheva.hay@fhfg.com",
//             "sum": 17
//         },
//         {
//             "First name": "George",
//             "How many new contacts did you have this week?": 7,
//             "What can we help you with this week?": "Review of Thursday’s LBS meeting",
//             "Last name": "Adams",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1683849600000,
//             "email": "george.adams@fhfg.com",
//             "sum": 27
//         },
//         {
//             "First name": "Derrick",
//             "How many new contacts did you have this week?": 25,
//             "What can we help you with this week?": "Finding networking/social events to meet new prospects",
//             "Last name": "Walters",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1683849600000,
//             "email": "Derrick.walters@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "Carole ",
//             "How many new contacts did you have this week?": 10,
//             "What can we help you with this week?": "I will have 5 meetings next week, would like to get a bit more proficient with LBS.",
//             "Last name": "Dixon ",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 4,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1683590400000,
//             "email": "carole.dixon@fhfg.com",
//             "sum": 35
//         },
//         {
//             "First name": "Pablo",
//             "How many new contacts did you have this week?": 5,
//             "What can we help you with this week?": "N/A",
//             "Last name": "Idrovo",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1683590400000,
//             "email": "pablo.idrovo@fhfg.com",
//             "sum": 20
//         },
//         {
//             "First name": "George",
//             "How many new contacts did you have this week?": 8,
//             "What can we help you with this week?": "Practice objection handling for setting a meeting",
//             "Last name": "Adams",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 1,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1683590400000,
//             "email": "george.adams@fhfg.com",
//             "sum": 23
//         },
//         {
//             "First name": "Tim",
//             "How many new contacts did you have this week?": 3,
//             "What can we help you with this week?": "Helping me plan to get to my first three months goal",
//             "Last name": "Colson",
//             "How many introductions did you receive this week?": 0,
//             "How many case opens did you have this week?": 0,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1683590400000,
//             "email": "timothy.colson@fhfg.com",
//             "sum": 8
//         },
//         {
//             "First name": "Max",
//             "How many new contacts did you have this week?": 12,
//             "What can we help you with this week?": "Managing client expectations and underwriting requirements.",
//             "Last name": "McKinney",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 6,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1683504000000,
//             "email": "max.mckinney@fhfg.com",
//             "sum": 50
//         },
//         {
//             "First name": "Suzanne",
//             "How many new contacts did you have this week?": 0,
//             "What can we help you with this week?": "N/A",
//             "Last name": "Schulze",
//             "How many introductions did you receive this week?": 1,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1683504000000,
//             "email": "suzanne.schulze@fhfg.com",
//             "sum": 15
//         },
//         {
//             "First name": "Mickey",
//             "How many new contacts did you have this week?": 9,
//             "What can we help you with this week?": "LBS and disability insurance.",
//             "Last name": "Wagner",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1683417600000,
//             "email": "mickey.wagner@fhfg.com",
//             "sum": 34
//         },
//         {
//             "First name": "Suzanne",
//             "How many new contacts did you have this week?": 13,
//             "What can we help you with this week?": "I'd like to roleplay more with LBS Open, Distribution Story, and FLO - who's interested?",
//             "Last name": "Schulze",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1682899200000,
//             "email": "suzanne.schulze@fhfg.com",
//             "sum": 25
//         },
//         {
//             "First name": "Pablo ",
//             "How many new contacts did you have this week?": 5,
//             "What can we help you with this week?": "Language when prospecting",
//             "Last name": "Idrovo",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1682640000000,
//             "email": "pablo.idrovo@fhfg.com",
//             "sum": 20
//         },
//         {
//             "First name": "Derrick",
//             "How many new contacts did you have this week?": 12,
//             "What can we help you with this week?": "N/A",
//             "Last name": "Walters",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1682640000000,
//             "email": "derrick.walters@fhfg.com",
//             "sum": 25
//         },
//         {
//             "First name": "George",
//             "How many new contacts did you have this week?": 7,
//             "What can we help you with this week?": "Underwriting obstacles",
//             "Last name": "Adams",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 1,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1682640000000,
//             "email": "george.adams@fhfg.com",
//             "sum": 17
//         },
//         {
//             "First name": "Mickey",
//             "How many new contacts did you have this week?": 8,
//             "What can we help you with this week?": "Onboarding",
//             "Last name": "Wagner",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1682640000000,
//             "email": "mickey.wagner@fhfg.com",
//             "sum": 33
//         },
//         {
//             "First name": "Max ",
//             "How many new contacts did you have this week?": 12,
//             "What can we help you with this week?": "Reached out to several grads about alumnae networking - how do I move to asking for an open?",
//             "Last name": "McKinney",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1682294400000,
//             "email": "max.mckinney@fhfg.com",
//             "sum": 35
//         },
//         {
//             "First name": "Suzanne",
//             "How many new contacts did you have this week?": 5,
//             "What can we help you with this week?": "Using LinkedIn for COI prospecting.",
//             "Last name": "Schulze",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1682294400000,
//             "email": "suzanne.schulze@fhfg.com",
//             "sum": 25
//         },
//         {
//             "First name": "Elisheva",
//             "How many new contacts did you have this week?": 4,
//             "What can we help you with this week?": "Buckets",
//             "Last name": "Hay",
//             "How many introductions did you receive this week?": 1,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1682294400000,
//             "email": "elisheva.hay@fhfg.com",
//             "sum": 19
//         },
//         {
//             "First name": "Mickey",
//             "How many new contacts did you have this week?": 8,
//             "What can we help you with this week?": "Prospecting - Prospecting - Prospecting",
//             "Last name": "Wagner",
//             "How many introductions did you receive this week?": 9,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1682208000000,
//             "email": "mickey.wagner@fhfg.com",
//             "sum": 38
//         },
//         {
//             "First name": "Derrick",
//             "How many new contacts did you have this week?": 8,
//             "What can we help you with this week?": "More practice on COI conversations and LBS demo (client data entry and presentation - 2nd half)",
//             "Last name": "Walters",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1682035200000,
//             "email": "derrick.walters@fhfg.com",
//             "sum": 28
//         },
//         {
//             "First name": "George",
//             "How many new contacts did you have this week?": 3,
//             "What can we help you with this week?": "Already reached out to Amy on this but utilizing Smart Office so I do a better job of keeping track of where I am.  Thats my responsibility , but since I get a copy of these notes I need a reminder to organize",
//             "Last name": "Adams",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1682035200000,
//             "email": "george.adams@fhfg.com",
//             "sum": 18
//         },
//         {
//             "First name": "Carole",
//             "How many new contacts did you have this week?": 8,
//             "What can we help you with this week?": "Nothing really, I just need to increase productivity",
//             "Last name": "Dixon",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1681689600000,
//             "email": "carole.dixon@fhfg.com",
//             "sum": 23
//         },
//         {
//             "First name": "Elisheva",
//             "How many new contacts did you have this week?": 1,
//             "What can we help you with this week?": "Planning for younger people coming out of college",
//             "Last name": "Hay",
//             "How many introductions did you receive this week?": 0,
//             "How many case opens did you have this week?": 0,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1681689600000,
//             "email": "elisheva.hay@fhfg.com",
//             "sum": 1
//         },
//         {
//             "First name": "Max",
//             "How many new contacts did you have this week?": 15,
//             "What can we help you with this week?": "DI policy design for medical market",
//             "Last name": "McKinney",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1681689600000,
//             "email": "max.mckinney@fhfg.com",
//             "sum": 35
//         },
//         {
//             "First name": "George",
//             "How many new contacts did you have this week?": 4,
//             "What can we help you with this week?": "Help with cold calling",
//             "Last name": "Adams",
//             "How many introductions did you receive this week?": 0,
//             "How many case opens did you have this week?": 0,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1681689600000,
//             "email": "george.adams@fhfg.com",
//             "sum": 4
//         },
//         {
//             "First name": "Suzanne",
//             "How many new contacts did you have this week?": 2,
//             "What can we help you with this week?": "401(k) Tracking",
//             "Last name": "Schulze",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 4,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1681689600000,
//             "email": "suzanne.schulze@fhfg.com",
//             "sum": 27
//         },
//         {
//             "First name": "Mickey",
//             "How many new contacts did you have this week?": 13,
//             "What can we help you with this week?": null,
//             "Last name": "Wagner",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 4,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1681603200000,
//             "email": "mickey.wagner@fhfg.com",
//             "sum": 40
//         },
//         {
//             "First name": "Carole",
//             "How many new contacts did you have this week?": 7,
//             "What can we help you with this week?": null,
//             "Last name": "Dixon",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 4,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1681084800000,
//             "email": "carole.dixon@fhfg.com",
//             "sum": 37
//         },
//         {
//             "First name": "Mickey",
//             "How many new contacts did you have this week?": 6,
//             "What can we help you with this week?": null,
//             "Last name": "Wagner",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1681084800000,
//             "email": "mickey.wagner@fhfg.com",
//             "sum": 26
//         },
//         {
//             "First name": "Max",
//             "How many new contacts did you have this week?": 16,
//             "What can we help you with this week?": null,
//             "Last name": "McKinney",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 4,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1680825600000,
//             "email": "max.mckinney@fhfg.com",
//             "sum": 35
//         },
//         {
//             "First name": "Elisheva",
//             "How many new contacts did you have this week?": 3,
//             "What can we help you with this week?": null,
//             "Last name": "Hay",
//             "How many introductions did you receive this week?": 1,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1680480000000,
//             "email": "elisheva.hay@fhfg.com",
//             "sum": 23
//         },
//         {
//             "First name": "Suzanne",
//             "How many new contacts did you have this week?": 14,
//             "What can we help you with this week?": null,
//             "Last name": "Schulze",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 0,
//             "How many COI meetings did you have this week?": 4,
//             "Submitted At": 1680480000000,
//             "email": "suzanne.schulze@fhfg.com",
//             "sum": 15
//         },
//         {
//             "First name": "Mickey",
//             "How many new contacts did you have this week?": 11,
//             "What can we help you with this week?": null,
//             "Last name": "Wagner",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1680393600000,
//             "email": "mickey.wagner@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "Derrick",
//             "How many new contacts did you have this week?": 10,
//             "What can we help you with this week?": null,
//             "Last name": "Walters",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 0,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1680393600000,
//             "email": "derrick.walters@fhfg.com",
//             "sum": 20
//         },
//         {
//             "First name": "Pablo",
//             "How many new contacts did you have this week?": 4,
//             "What can we help you with this week?": null,
//             "Last name": "Idrovo",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1680220800000,
//             "email": "pablo.idrovo@fhfg.com",
//             "sum": 19
//         },
//         {
//             "First name": "Max",
//             "How many new contacts did you have this week?": 18,
//             "What can we help you with this week?": null,
//             "Last name": "McKinney",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 6,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1680220800000,
//             "email": "max.mckinney@fhfg.com",
//             "sum": 50
//         },
//         {
//             "First name": "George",
//             "How many new contacts did you have this week?": 4,
//             "What can we help you with this week?": null,
//             "Last name": "Adams",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1680220800000,
//             "email": "george.adams@fhfg.com",
//             "sum": 19
//         },
//         {
//             "First name": "Max",
//             "How many new contacts did you have this week?": 24,
//             "What can we help you with this week?": null,
//             "Last name": "McKinney",
//             "How many introductions did you receive this week?": 6,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1679875200000,
//             "email": "max.mckinney@fhfg.com",
//             "sum": 35
//         },
//         {
//             "First name": "Carole",
//             "How many new contacts did you have this week?": 12,
//             "What can we help you with this week?": null,
//             "Last name": "Dixon",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1679875200000,
//             "email": "carole.dixon@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "Elisheva",
//             "How many new contacts did you have this week?": 6,
//             "What can we help you with this week?": null,
//             "Last name": "Hay",
//             "How many introductions did you receive this week?": 0,
//             "How many case opens did you have this week?": 0,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1679875200000,
//             "email": "elisheva.hay@fhfg.com",
//             "sum": 11
//         },
//         {
//             "First name": "Suzanne",
//             "How many new contacts did you have this week?": 8,
//             "What can we help you with this week?": null,
//             "Last name": "Schulze",
//             "How many introductions did you receive this week?": 1,
//             "How many case opens did you have this week?": 0,
//             "How many COI meetings did you have this week?": 4,
//             "Submitted At": 1679788800000,
//             "email": "suzanne.schulze@fhfg.com",
//             "sum": 13
//         },
//         {
//             "First name": "Mickey",
//             "How many new contacts did you have this week?": 13,
//             "What can we help you with this week?": null,
//             "Last name": "Wagner",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 1,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1679788800000,
//             "email": "mickey.wagner@fhfg.com",
//             "sum": 25
//         },
//         {
//             "First name": "Derrick",
//             "How many new contacts did you have this week?": 17,
//             "What can we help you with this week?": null,
//             "Last name": "Walters",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1679616000000,
//             "email": "derrick.walters@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "George",
//             "How many new contacts did you have this week?": 7,
//             "What can we help you with this week?": null,
//             "Last name": "Adams",
//             "How many introductions did you receive this week?": 1,
//             "How many case opens did you have this week?": 0,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1679616000000,
//             "email": "george.adams@fhfg.com",
//             "sum": 12
//         },
//         {
//             "First name": "Max",
//             "How many new contacts did you have this week?": 15,
//             "What can we help you with this week?": null,
//             "Last name": "McKinney",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1679270400000,
//             "email": "max.mckinney@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "Suzanne",
//             "How many new contacts did you have this week?": 10,
//             "What can we help you with this week?": null,
//             "Last name": "Schulze",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1679270400000,
//             "email": "suzanne.schulze@fhfg.com",
//             "sum": 35
//         },
//         {
//             "First name": "Mickey",
//             "How many new contacts did you have this week?": 21,
//             "What can we help you with this week?": null,
//             "Last name": "Wagner",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1679270400000,
//             "email": "mickey.wagner@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "Carole",
//             "How many new contacts did you have this week?": 5,
//             "What can we help you with this week?": null,
//             "Last name": "Dixon",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 4,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1679184000000,
//             "email": "carole.dixon@fhfg.com",
//             "sum": 35
//         },
//         {
//             "First name": "Elisheva",
//             "How many new contacts did you have this week?": 7,
//             "What can we help you with this week?": null,
//             "Last name": "Hay",
//             "How many introductions did you receive this week?": 0,
//             "How many case opens did you have this week?": 1,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1679011200000,
//             "email": "elisheva.hay@fhfg.com",
//             "sum": 17
//         },
//         {
//             "First name": "Derrick",
//             "How many new contacts did you have this week?": 12,
//             "What can we help you with this week?": null,
//             "Last name": "Walters",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 1,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1679011200000,
//             "email": "derrick.walters@fhfg.com",
//             "sum": 20
//         },
//         {
//             "First name": "George",
//             "How many new contacts did you have this week?": 4,
//             "What can we help you with this week?": null,
//             "Last name": "Adams",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 1,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1679011200000,
//             "email": "george.adams@fhfg.com",
//             "sum": 19
//         },
//         {
//             "First name": "Carole",
//             "How many new contacts did you have this week?": 14,
//             "What can we help you with this week?": null,
//             "Last name": "Dixon",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1678665600000,
//             "email": "carole.dixon@fhfg.com",
//             "sum": 25
//         },
//         {
//             "First name": "Lily",
//             "How many new contacts did you have this week?": 2,
//             "What can we help you with this week?": null,
//             "Last name": "Lam",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1678665600000,
//             "email": "Lily.c.lam@fhfg.com",
//             "sum": 17
//         },
//         {
//             "First name": "Mickey",
//             "How many new contacts did you have this week?": 41,
//             "What can we help you with this week?": null,
//             "Last name": "Wagner",
//             "How many introductions did you receive this week?": 6,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1678665600000,
//             "email": "mickey.wagner@fhfg.com",
//             "sum": 35
//         },
//         {
//             "First name": "Elisheva",
//             "How many new contacts did you have this week?": 1,
//             "What can we help you with this week?": null,
//             "Last name": "Hay",
//             "How many introductions did you receive this week?": 1,
//             "How many case opens did you have this week?": 1,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1678579200000,
//             "email": "elisheva.hay@fhfg.com",
//             "sum": 11
//         },
//         {
//             "First name": "George",
//             "How many new contacts did you have this week?": 7,
//             "What can we help you with this week?": null,
//             "Last name": "Adams",
//             "How many introductions did you receive this week?": 1,
//             "How many case opens did you have this week?": 0,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1678406400000,
//             "email": "george.adams@fhfg.com",
//             "sum": 12
//         },
//         {
//             "First name": "Max ",
//             "How many new contacts did you have this week?": 22,
//             "What can we help you with this week?": null,
//             "Last name": "McKinney",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 4,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1678406400000,
//             "email": "max.mckinney@fhfg.com",
//             "sum": 35
//         },
//         {
//             "First name": "Carole",
//             "How many new contacts did you have this week?": 8,
//             "What can we help you with this week?": null,
//             "Last name": "Dixon",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1678060800000,
//             "email": "carole.dixon@fhfg.com",
//             "sum": 28
//         },
//         {
//             "First name": "Mickey",
//             "How many new contacts did you have this week?": 8,
//             "What can we help you with this week?": null,
//             "Last name": "Wagner",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1678060800000,
//             "email": "mickey.wagner@fhfg.com",
//             "sum": 23
//         },
//         {
//             "First name": "Elisheva",
//             "How many new contacts did you have this week?": 1,
//             "What can we help you with this week?": null,
//             "Last name": "Hay",
//             "How many introductions did you receive this week?": 1,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1677974400000,
//             "email": "elisheva.hay@fhfg.com",
//             "sum": 16
//         },
//         {
//             "First name": "George",
//             "How many new contacts did you have this week?": 4,
//             "What can we help you with this week?": null,
//             "Last name": "Adams",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1677801600000,
//             "email": "george.adams@fhfg.com",
//             "sum": 19
//         },
//         {
//             "First name": "Pablo",
//             "How many new contacts did you have this week?": 4,
//             "What can we help you with this week?": null,
//             "Last name": "Idrovo",
//             "How many introductions did you receive this week?": 1,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1677801600000,
//             "email": "pablo.idrovo@fhfg.com",
//             "sum": 19
//         },
//         {
//             "First name": "Suzanne",
//             "How many new contacts did you have this week?": 2,
//             "What can we help you with this week?": null,
//             "Last name": "Schulze",
//             "How many introductions did you receive this week?": 1,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1677456000000,
//             "email": "suzanne.schulze@fhfg.com",
//             "sum": 17
//         },
//         {
//             "First name": "Carole ",
//             "How many new contacts did you have this week?": 14,
//             "What can we help you with this week?": null,
//             "Last name": "Dixon",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 4,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1677456000000,
//             "email": "carole.dixon@fhfg.com",
//             "sum": 35
//         },
//         {
//             "First name": "Mickey",
//             "How many new contacts did you have this week?": 14,
//             "What can we help you with this week?": null,
//             "Last name": "Wagner",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1677456000000,
//             "email": "mickey.wagner@fhfg.com",
//             "sum": 35
//         },
//         {
//             "First name": "Max",
//             "How many new contacts did you have this week?": 16,
//             "What can we help you with this week?": null,
//             "Last name": "McKinney",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1677369600000,
//             "email": "max.mckinney@fhfg.com",
//             "sum": 35
//         },
//         {
//             "First name": "Lily",
//             "How many new contacts did you have this week?": 2,
//             "What can we help you with this week?": null,
//             "Last name": "Lam",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1677283200000,
//             "email": "Lily.c.lam@fhfg.com",
//             "sum": 17
//         },
//         {
//             "First name": "Pablo",
//             "How many new contacts did you have this week?": 5,
//             "What can we help you with this week?": null,
//             "Last name": "Idrovo",
//             "How many introductions did you receive this week?": 1,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1677196800000,
//             "email": "pablo.idrovo@fhfg.com",
//             "sum": 20
//         },
//         {
//             "First name": "Elisheva",
//             "How many new contacts did you have this week?": 6,
//             "What can we help you with this week?": null,
//             "Last name": "Hay",
//             "How many introductions did you receive this week?": 1,
//             "How many case opens did you have this week?": 1,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1677196800000,
//             "email": "elisheva.hay@fhfg.com",
//             "sum": 16
//         },
//         {
//             "First name": "George",
//             "How many new contacts did you have this week?": 13,
//             "What can we help you with this week?": null,
//             "Last name": "Adams",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 0,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1677196800000,
//             "email": "george.adams@fhfg.com",
//             "sum": 15
//         },
//         {
//             "First name": "Elisheva",
//             "How many new contacts did you have this week?": 4,
//             "What can we help you with this week?": null,
//             "Last name": "Hay",
//             "How many introductions did you receive this week?": 0,
//             "How many case opens did you have this week?": 1,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1676851200000,
//             "email": "elisheva.hay@fhfg.com",
//             "sum": 14
//         },
//         {
//             "First name": "Mickey",
//             "How many new contacts did you have this week?": 6,
//             "What can we help you with this week?": null,
//             "Last name": "Wagner",
//             "How many introductions did you receive this week?": 6,
//             "How many case opens did you have this week?": 1,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1676851200000,
//             "email": "mickey.wagner@fhfg.com",
//             "sum": 21
//         },
//         {
//             "First name": "Max",
//             "How many new contacts did you have this week?": 22,
//             "What can we help you with this week?": null,
//             "Last name": "McKinney",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 4,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1676505600000,
//             "email": "max.mckinney@fhfg.com",
//             "sum": 35
//         },
//         {
//             "First name": "Giovanni",
//             "How many new contacts did you have this week?": 5,
//             "What can we help you with this week?": null,
//             "Last name": "Frisenda",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 1,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1676246400000,
//             "email": "giovanni.frisenda@fhfg.com",
//             "sum": 15
//         },
//         {
//             "First name": "Suzanne",
//             "How many new contacts did you have this week?": 3,
//             "What can we help you with this week?": null,
//             "Last name": "Schulze",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 1,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1676246400000,
//             "email": "suzanne.schulze@fhfg.com",
//             "sum": 13
//         },
//         {
//             "First name": "Carole",
//             "How many new contacts did you have this week?": 16,
//             "What can we help you with this week?": null,
//             "Last name": "Dixon",
//             "How many introductions did you receive this week?": 1,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1676246400000,
//             "email": "carole.dixon@fhfg.com",
//             "sum": 25
//         },
//         {
//             "First name": "Mickey",
//             "How many new contacts did you have this week?": 7,
//             "What can we help you with this week?": null,
//             "Last name": "Wagner",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 0,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1676246400000,
//             "email": "mickey.wagner@fhfg.com",
//             "sum": 12
//         },
//         {
//             "First name": "Lily",
//             "How many new contacts did you have this week?": 3,
//             "What can we help you with this week?": null,
//             "Last name": "Lam",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1676246400000,
//             "email": "Lily.c.lam@fhfg.com",
//             "sum": 23
//         },
//         {
//             "First name": "Derrick",
//             "How many new contacts did you have this week?": 8,
//             "What can we help you with this week?": null,
//             "Last name": "Walters",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 1,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1675987200000,
//             "email": "derrick.walters@fhfg.com",
//             "sum": 18
//         },
//         {
//             "First name": "Elisheva",
//             "How many new contacts did you have this week?": 6,
//             "What can we help you with this week?": null,
//             "Last name": "Hay",
//             "How many introductions did you receive this week?": 1,
//             "How many case opens did you have this week?": 0,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1675987200000,
//             "email": "elisheva.hay@fhfg.com",
//             "sum": 6
//         },
//         {
//             "First name": "George",
//             "How many new contacts did you have this week?": 10,
//             "What can we help you with this week?": null,
//             "Last name": "Adams",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 11,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1675987200000,
//             "email": "george.adams@fhfg.com",
//             "sum": 75
//         },
//         {
//             "First name": "Elisheva",
//             "How many new contacts did you have this week?": 1,
//             "What can we help you with this week?": null,
//             "Last name": "Hay",
//             "How many introductions did you receive this week?": 0,
//             "How many case opens did you have this week?": 1,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1675728000000,
//             "email": "elisheva.hay@fhfg.com",
//             "sum": 6
//         },
//         {
//             "First name": "Derrick",
//             "How many new contacts did you have this week?": 6,
//             "What can we help you with this week?": null,
//             "Last name": "Walters",
//             "How many introductions did you receive this week?": 1,
//             "How many case opens did you have this week?": 0,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1675641600000,
//             "email": "derrick.walters@fhfg.com",
//             "sum": 11
//         },
//         {
//             "First name": "Mickey",
//             "How many new contacts did you have this week?": 10,
//             "What can we help you with this week?": null,
//             "Last name": "Wagner",
//             "How many introductions did you receive this week?": 1,
//             "How many case opens did you have this week?": 0,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1675641600000,
//             "email": "mickey.wagner@fhfg.com",
//             "sum": 15
//         },
//         {
//             "First name": "Lily",
//             "How many new contacts did you have this week?": 12,
//             "What can we help you with this week?": null,
//             "Last name": "Lam",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 0,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1675641600000,
//             "email": "lily.c.lam@fhfg.com",
//             "sum": 15
//         },
//         {
//             "First name": "Giovanni",
//             "How many new contacts did you have this week?": 7,
//             "What can we help you with this week?": null,
//             "Last name": "Frisenda",
//             "How many introductions did you receive this week?": 1,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1675641600000,
//             "email": "giovanni.frisenda@fhfg.com",
//             "sum": 22
//         },
//         {
//             "First name": "Max",
//             "How many new contacts did you have this week?": 13,
//             "What can we help you with this week?": null,
//             "Last name": "McKinney",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1675555200000,
//             "email": "max.mckinney@fhfg.com",
//             "sum": 25
//         },
//         {
//             "First name": "Carole",
//             "How many new contacts did you have this week?": 6,
//             "What can we help you with this week?": null,
//             "Last name": "Dixon",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1675555200000,
//             "email": "carole.dixon@fhfg.com",
//             "sum": 26
//         },
//         {
//             "First name": "Suzanne ",
//             "How many new contacts did you have this week?": 4,
//             "What can we help you with this week?": null,
//             "Last name": "Schulze",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1675382400000,
//             "email": "suzanne.schulze@fhfg.com",
//             "sum": 24
//         },
//         {
//             "First name": "George",
//             "How many new contacts did you have this week?": 2,
//             "What can we help you with this week?": null,
//             "Last name": "Adams",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 4,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1675382400000,
//             "email": "george.adams@fhfg.com",
//             "sum": 27
//         },
//         {
//             "First name": "Suzanne",
//             "How many new contacts did you have this week?": 3,
//             "What can we help you with this week?": null,
//             "Last name": "Schulze",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1675036800000,
//             "email": "suzanne.schulze@fhfg.com",
//             "sum": 18
//         },
//         {
//             "First name": "Max ",
//             "How many new contacts did you have this week?": 12,
//             "What can we help you with this week?": null,
//             "Last name": "McKinney",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1675036800000,
//             "email": "max.mckinney@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "Lily",
//             "How many new contacts did you have this week?": 2,
//             "What can we help you with this week?": null,
//             "Last name": "Lam",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 0,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1674950400000,
//             "email": "lily.c.lam@fhfg.com",
//             "sum": 7
//         },
//         {
//             "First name": "Carole",
//             "How many new contacts did you have this week?": 11,
//             "What can we help you with this week?": null,
//             "Last name": "Dixon",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1674950400000,
//             "email": "carole.dixon@fhfg.com",
//             "sum": 25
//         },
//         {
//             "First name": "Mickey",
//             "How many new contacts did you have this week?": 3,
//             "What can we help you with this week?": null,
//             "Last name": "Wagner",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 0,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1674777600000,
//             "email": "mickey.wagner@fhfg.com",
//             "sum": 8
//         },
//         {
//             "First name": "Elisheva",
//             "How many new contacts did you have this week?": 4,
//             "What can we help you with this week?": null,
//             "Last name": "Hay",
//             "How many introductions did you receive this week?": 0,
//             "How many case opens did you have this week?": 1,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1674777600000,
//             "email": "elisheva.hay@fhfg.com",
//             "sum": 14
//         },
//         {
//             "First name": "George",
//             "How many new contacts did you have this week?": 1,
//             "What can we help you with this week?": null,
//             "Last name": "Adams",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1674777600000,
//             "email": "george.adams@fhfg.com",
//             "sum": 11
//         },
//         {
//             "First name": "Derrick",
//             "How many new contacts did you have this week?": 12,
//             "What can we help you with this week?": null,
//             "Last name": "Walters",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 1,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1674777600000,
//             "email": "derrick.walters@fhfg.com",
//             "sum": 20
//         },
//         {
//             "First name": "Derrick",
//             "How many new contacts did you have this week?": 6,
//             "What can we help you with this week?": null,
//             "Last name": "Walters",
//             "How many introductions did you receive this week?": 0,
//             "How many case opens did you have this week?": 1,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1674432000000,
//             "email": "derrick.walters@fhfg.com",
//             "sum": 11
//         },
//         {
//             "First name": "Max",
//             "How many new contacts did you have this week?": 32,
//             "What can we help you with this week?": null,
//             "Last name": "McKinney",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1674432000000,
//             "email": "max.mckinney@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "Evan",
//             "How many new contacts did you have this week?": 8,
//             "What can we help you with this week?": null,
//             "Last name": "Khan",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1674432000000,
//             "email": "evan.khan@fhfg.com",
//             "sum": 33
//         },
//         {
//             "First name": "Suzanne",
//             "How many new contacts did you have this week?": 2,
//             "What can we help you with this week?": null,
//             "Last name": "Schulze",
//             "How many introductions did you receive this week?": 0,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1674432000000,
//             "email": "suzanne.schulze@fhfg.com",
//             "sum": 22
//         },
//         {
//             "First name": "Carole",
//             "How many new contacts did you have this week?": 5,
//             "What can we help you with this week?": null,
//             "Last name": "Dixon",
//             "How many introductions did you receive this week?": 1,
//             "How many case opens did you have this week?": 1,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1674172800000,
//             "email": "carole.dixon@fhfg.com",
//             "sum": 15
//         },
//         {
//             "First name": "Lily",
//             "How many new contacts did you have this week?": 1,
//             "What can we help you with this week?": null,
//             "Last name": "Lam",
//             "How many introductions did you receive this week?": 0,
//             "How many case opens did you have this week?": 0,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1674172800000,
//             "email": "lily.c.lam@fhfg.com",
//             "sum": 1
//         },
//         {
//             "First name": "Elisheva",
//             "How many new contacts did you have this week?": 7,
//             "What can we help you with this week?": null,
//             "Last name": "Hay",
//             "How many introductions did you receive this week?": 1,
//             "How many case opens did you have this week?": 0,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1674172800000,
//             "email": "elisheva.hay@fhfg.com",
//             "sum": 12
//         },
//         {
//             "First name": "Mickey",
//             "How many new contacts did you have this week?": 5,
//             "What can we help you with this week?": null,
//             "Last name": "Wagner",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 1,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1674172800000,
//             "email": "mickey.wagner@fhfg.com",
//             "sum": 15
//         },
//         {
//             "First name": "Giovanni",
//             "How many new contacts did you have this week?": 12,
//             "What can we help you with this week?": null,
//             "Last name": "Frisenda",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1674172800000,
//             "email": "giovanni.frisenda@fhfg.com",
//             "sum": 20
//         },
//         {
//             "First name": "George",
//             "How many new contacts did you have this week?": 4,
//             "What can we help you with this week?": null,
//             "Last name": "Adams",
//             "How many introductions did you receive this week?": 1,
//             "How many case opens did you have this week?": 1,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1674172800000,
//             "email": "george.adams@fhfg.com",
//             "sum": 9
//         },
//         {
//             "First name": "Mickey",
//             "How many new contacts did you have this week?": 6,
//             "What can we help you with this week?": null,
//             "Last name": "Wagner",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 1,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1673568000000,
//             "email": "mickey.wagner@fhfg.com",
//             "sum": 16
//         },
//         {
//             "First name": "Suzanne",
//             "How many new contacts did you have this week?": 5,
//             "What can we help you with this week?": null,
//             "Last name": "Schulze",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 9,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1673568000000,
//             "email": "suzanne.schulze@fhfg.com",
//             "sum": 55
//         },
//         {
//             "First name": "George",
//             "How many new contacts did you have this week?": 0,
//             "What can we help you with this week?": null,
//             "Last name": "Adams",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1673568000000,
//             "email": "george.adams@fhfg.com",
//             "sum": 20
//         },
//         {
//             "First name": "Richard",
//             "How many new contacts did you have this week?": 18,
//             "What can we help you with this week?": null,
//             "Last name": "Piazza",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1673568000000,
//             "email": "richard.piazza@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "Carole ",
//             "How many new contacts did you have this week?": 14,
//             "What can we help you with this week?": null,
//             "Last name": "Dixon",
//             "How many introductions did you receive this week?": 1,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 4,
//             "Submitted At": 1673568000000,
//             "email": "carole.dixon@fhfg.com",
//             "sum": 25
//         },
//         {
//             "First name": "Derrick",
//             "How many new contacts did you have this week?": 35,
//             "What can we help you with this week?": null,
//             "Last name": "Walters",
//             "How many introductions did you receive this week?": 1,
//             "How many case opens did you have this week?": 4,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1673568000000,
//             "email": "derrick.walters@fhfg.com",
//             "sum": 35
//         },
//         {
//             "First name": "Max ",
//             "How many new contacts did you have this week?": 13,
//             "What can we help you with this week?": null,
//             "Last name": "McKinney",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1673568000000,
//             "email": "max.mckinney@fhfg.com",
//             "sum": 35
//         },
//         {
//             "First name": "Pablo ",
//             "How many new contacts did you have this week?": 4,
//             "What can we help you with this week?": null,
//             "Last name": "Idrovo",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1673568000000,
//             "email": "pablo.idrovo@fhfg.com",
//             "sum": 19
//         },
//         {
//             "First name": "Pablo ",
//             "How many new contacts did you have this week?": 2,
//             "What can we help you with this week?": null,
//             "Last name": "Idrovo",
//             "How many introductions did you receive this week?": 1,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1673222400000,
//             "email": "pablo.idrovo@fhfg.com",
//             "sum": 17
//         },
//         {
//             "First name": "Evan",
//             "How many new contacts did you have this week?": 8,
//             "What can we help you with this week?": null,
//             "Last name": "Khan",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1673222400000,
//             "email": "evan.khan@fhfg.com",
//             "sum": 33
//         },
//         {
//             "First name": "Mickey",
//             "How many new contacts did you have this week?": 6,
//             "What can we help you with this week?": null,
//             "Last name": "Wagner",
//             "How many introductions did you receive this week?": 1,
//             "How many case opens did you have this week?": 1,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1673222400000,
//             "email": "mickey.wagner@fhfg.com",
//             "sum": 16
//         },
//         {
//             "First name": "Carole",
//             "How many new contacts did you have this week?": 12,
//             "What can we help you with this week?": null,
//             "Last name": "Dixon",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 1,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1673136000000,
//             "email": "carole.dixon@fhfg.com",
//             "sum": 20
//         },
//         {
//             "First name": "Giovanni",
//             "How many new contacts did you have this week?": 6,
//             "What can we help you with this week?": null,
//             "Last name": "Frisenda",
//             "How many introductions did you receive this week?": 1,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1673136000000,
//             "email": "giovanni.frisenda@fhfg.com",
//             "sum": 21
//         },
//         {
//             "First name": "Richard",
//             "How many new contacts did you have this week?": 7,
//             "What can we help you with this week?": null,
//             "Last name": "Piazza",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1672963200000,
//             "email": "richard.piazza@fhfg.com",
//             "sum": 17
//         },
//         {
//             "First name": "Elisheva",
//             "How many new contacts did you have this week?": 5,
//             "What can we help you with this week?": null,
//             "Last name": "Hay",
//             "How many introductions did you receive this week?": 1,
//             "How many case opens did you have this week?": 0,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1672963200000,
//             "email": "elisheva.hay@fhfg.com",
//             "sum": 5
//         },
//         {
//             "First name": "George",
//             "How many new contacts did you have this week?": 3,
//             "What can we help you with this week?": null,
//             "Last name": "Adams",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1672963200000,
//             "email": "george.adams@fhfg.com",
//             "sum": 23
//         },
//         {
//             "First name": "Derrick",
//             "How many new contacts did you have this week?": 15,
//             "What can we help you with this week?": null,
//             "Last name": "Walters",
//             "How many introductions did you receive this week?": 0,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1672963200000,
//             "email": "derrick.walters@fhfg.com",
//             "sum": 20
//         },
//         {
//             "First name": "Max",
//             "How many new contacts did you have this week?": 12,
//             "What can we help you with this week?": null,
//             "Last name": "McKinney",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 5,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1672963200000,
//             "email": "max.mckinney@fhfg.com",
//             "sum": 40
//         }
//     ],
//     "recruiting": [
//         {
//             "First name": "Richard",
//             "How many new contacts did you have this week?": 12,
//             "What can we help you with this week?": "Whole life juvenile policies",
//             "Last name": "Piazza",
//             "How many introductions did you receive this week?": 6,
//             "How many case opens did you have this week?": 1,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1689206400000,
//             "email": "richard.piazza@fhfg.com",
//             "sum": 25
//         },
//         {
//             "First name": "Evelyn",
//             "How many new contacts did you have this week?": 22,
//             "What can we help you with this week?": "Child WL policies",
//             "Last name": "Gellar",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1689206400000,
//             "email": "evelyn.gellar@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "Kristen",
//             "How many new contacts did you have this week?": 20,
//             "What can we help you with this week?": "linkedIn ice breaking language",
//             "Last name": "LaMarca",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 5,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1689206400000,
//             "email": "kristen.lamarca@fhfg.com",
//             "sum": 40
//         },
//         {
//             "First name": "Evelyn",
//             "How many new contacts did you have this week?": 14,
//             "What can we help you with this week?": "New language leading in to first call- I'll explain what I mean on call",
//             "Last name": "Gellar",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1688688000000,
//             "email": "Evelyn.Gellar@fhfg.com",
//             "sum": 25
//         },
//         {
//             "First name": "John",
//             "How many new contacts did you have this week?": 22,
//             "What can we help you with this week?": "3",
//             "Last name": "Wool",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 4,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1688688000000,
//             "email": "john.wool@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "Stephen ",
//             "How many new contacts did you have this week?": 14,
//             "What can we help you with this week?": "",
//             "Last name": "DelliBovi",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 1,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1688688000000,
//             "email": "stephen.dellibovi@fhfg.com",
//             "sum": 20
//         },
//         {
//             "First name": "Richard",
//             "How many new contacts did you have this week?": 14,
//             "What can we help you with this week?": null,
//             "Last name": "Piazza",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1688688000000,
//             "email": "richard.piazza@fhfg.com",
//             "sum": 35
//         },
//         {
//             "First name": "Kristen",
//             "How many new contacts did you have this week?": 10,
//             "What can we help you with this week?": null,
//             "Last name": "LaMarca",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 7,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1688601600000,
//             "email": "kristen.lamarca@fhfg.com",
//             "sum": 55
//         },
//         {
//             "First name": "Evelyn",
//             "How many new contacts did you have this week?": 34,
//             "What can we help you with this week?": null,
//             "Last name": "Gellar",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1687996800000,
//             "email": "Evelyn.Gellar@fhfg.com",
//             "sum": 25
//         },
//         {
//             "First name": "Kristen",
//             "How many new contacts did you have this week?": 18,
//             "What can we help you with this week?": null,
//             "Last name": "LaMarca",
//             "How many introductions did you receive this week?": 6,
//             "How many case opens did you have this week?": 6,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1687996800000,
//             "email": "kristen.lamarca@fhfg.com",
//             "sum": 50
//         },
//         {
//             "First name": "Stephen ",
//             "How many new contacts did you have this week?": 11,
//             "What can we help you with this week?": null,
//             "Last name": "DelliBovi",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1687478400000,
//             "email": "stephen.dellibovi@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "Richard",
//             "How many new contacts did you have this week?": 7,
//             "What can we help you with this week?": null,
//             "Last name": "Piazza",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1687478400000,
//             "email": "richard.piazza@fhfg.com",
//             "sum": 17
//         },
//         {
//             "First name": "John",
//             "How many new contacts did you have this week?": 24,
//             "What can we help you with this week?": null,
//             "Last name": "Wool",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 6,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1687392000000,
//             "email": "john.wool@fhfg.com",
//             "sum": 40
//         },
//         {
//             "First name": "Kristen",
//             "How many new contacts did you have this week?": 12,
//             "What can we help you with this week?": null,
//             "Last name": "LaMarca",
//             "How many introductions did you receive this week?": 9,
//             "How many case opens did you have this week?": 9,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1687392000000,
//             "email": "kristen.lamarca@fhfg.com",
//             "sum": 65
//         },
//         {
//             "First name": "Stephen ",
//             "How many new contacts did you have this week?": 11,
//             "What can we help you with this week?": null,
//             "Last name": "DelliBovi",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1686873600000,
//             "email": "stephen.dellibovi@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "Evelyn",
//             "How many new contacts did you have this week?": 8,
//             "What can we help you with this week?": null,
//             "Last name": "Gellar",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1686873600000,
//             "email": "Evelyn.Gellar@fhfg.com",
//             "sum": 18
//         },
//         {
//             "First name": "Kristen",
//             "How many new contacts did you have this week?": 15,
//             "What can we help you with this week?": null,
//             "Last name": "LaMarca",
//             "How many introductions did you receive this week?": 6,
//             "How many case opens did you have this week?": 6,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1686787200000,
//             "email": "kristen.lamarca@fhfg.com",
//             "sum": 45
//         },
//         {
//             "First name": "John",
//             "How many new contacts did you have this week?": 29,
//             "What can we help you with this week?": null,
//             "Last name": "Wool",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 7,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1686787200000,
//             "email": "john.wool@fhfg.com",
//             "sum": 55
//         },
//         {
//             "First name": "Evelyn",
//             "How many new contacts did you have this week?": 22,
//             "What can we help you with this week?": null,
//             "Last name": "Gellar",
//             "How many introductions did you receive this week?": 1,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1686268800000,
//             "email": "Evelyn.Gellar@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "Richard",
//             "How many new contacts did you have this week?": 16,
//             "What can we help you with this week?": null,
//             "Last name": "Piazza",
//             "How many introductions did you receive this week?": 7,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1686268800000,
//             "email": "richard.piazza@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "John",
//             "How many new contacts did you have this week?": 36,
//             "What can we help you with this week?": null,
//             "Last name": "Wool",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 5,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1686182400000,
//             "email": "john.wool@fhfg.com",
//             "sum": 40
//         },
//         {
//             "First name": "Kristen",
//             "How many new contacts did you have this week?": 11,
//             "What can we help you with this week?": null,
//             "Last name": "LaMarca",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 5,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1686182400000,
//             "email": "kristen.lamarca@fhfg.com",
//             "sum": 40
//         },
//         {
//             "First name": "Stephen ",
//             "How many new contacts did you have this week?": 11,
//             "What can we help you with this week?": null,
//             "Last name": "DelliBovi",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1685664000000,
//             "email": "stephen.dellibovi@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "John",
//             "How many new contacts did you have this week?": 36,
//             "What can we help you with this week?": null,
//             "Last name": "Wool",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 5,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1685664000000,
//             "email": "john.wool@fhfg.com",
//             "sum": 40
//         },
//         {
//             "First name": "Evelyn",
//             "How many new contacts did you have this week?": 4,
//             "What can we help you with this week?": null,
//             "Last name": "Gellar",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1685577600000,
//             "email": "Evelyn.Gellar@fhfg.com",
//             "sum": 19
//         },
//         {
//             "First name": "Richard",
//             "How many new contacts did you have this week?": 14,
//             "What can we help you with this week?": null,
//             "Last name": "Piazza",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1685577600000,
//             "email": "richard.piazza@fhfg.com",
//             "sum": 25
//         },
//         {
//             "First name": "Kristen",
//             "How many new contacts did you have this week?": 23,
//             "What can we help you with this week?": null,
//             "Last name": "LaMarca",
//             "How many introductions did you receive this week?": 6,
//             "How many case opens did you have this week?": 6,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1685577600000,
//             "email": "kristen.lamarca@fhfg.com",
//             "sum": 45
//         },
//         {
//             "First name": "Richard",
//             "How many new contacts did you have this week?": 14,
//             "What can we help you with this week?": null,
//             "Last name": "Piazza",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1684972800000,
//             "email": "richard.piazza@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "Stephen",
//             "How many new contacts did you have this week?": 14,
//             "What can we help you with this week?": null,
//             "Last name": "DelliBovi",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1684972800000,
//             "email": "stephen.dellibovi@fhfg.com",
//             "sum": 25
//         },
//         {
//             "First name": "Evelyn",
//             "How many new contacts did you have this week?": 7,
//             "What can we help you with this week?": null,
//             "Last name": "Gellar",
//             "How many introductions did you receive this week?": 1,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1684972800000,
//             "email": "Evelyn.Gellar@fhfg.com",
//             "sum": 17
//         },
//         {
//             "First name": "John ",
//             "How many new contacts did you have this week?": 33,
//             "What can we help you with this week?": null,
//             "Last name": "Wool",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 5,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1684972800000,
//             "email": "john.wool@fhfg.com",
//             "sum": 40
//         },
//         {
//             "First name": "Kristen",
//             "How many new contacts did you have this week?": 10,
//             "What can we help you with this week?": null,
//             "Last name": "LaMarca",
//             "How many introductions did you receive this week?": 9,
//             "How many case opens did you have this week?": 9,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1684972800000,
//             "email": "kristen.lamarca@fhfg.com",
//             "sum": 65
//         },
//         {
//             "First name": "Stephen",
//             "How many new contacts did you have this week?": 14,
//             "What can we help you with this week?": null,
//             "Last name": "DelliBovi",
//             "How many introductions did you receive this week?": 6,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1684454400000,
//             "email": "stephen.dellibovi@fhfg.com",
//             "sum": 35
//         },
//         {
//             "First name": "Evelyn",
//             "How many new contacts did you have this week?": 9,
//             "What can we help you with this week?": null,
//             "Last name": "Gellar",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1684454400000,
//             "email": "Evelyn.Gellar@fhfg.com",
//             "sum": 29
//         },
//         {
//             "First name": "Richard",
//             "How many new contacts did you have this week?": 10,
//             "What can we help you with this week?": null,
//             "Last name": "Piazza",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1684368000000,
//             "email": "richard.piazza@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "John",
//             "How many new contacts did you have this week?": 29,
//             "What can we help you with this week?": null,
//             "Last name": "Wool",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 6,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1684368000000,
//             "email": "john.wool@fhfg.com",
//             "sum": 50
//         },
//         {
//             "First name": "Kristen",
//             "How many new contacts did you have this week?": 15,
//             "What can we help you with this week?": null,
//             "Last name": "LaMarca",
//             "How many introductions did you receive this week?": 6,
//             "How many case opens did you have this week?": 6,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1684368000000,
//             "email": "kristen.lamarca@fhfg.com",
//             "sum": 45
//         },
//         {
//             "First name": "John",
//             "How many new contacts did you have this week?": 33,
//             "What can we help you with this week?": null,
//             "Last name": "Wool",
//             "How many introductions did you receive this week?": 6,
//             "How many case opens did you have this week?": 6,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1683849600000,
//             "email": "john.wool@fhfg.com",
//             "sum": 45
//         },
//         {
//             "First name": "Stephen ",
//             "How many new contacts did you have this week?": 11,
//             "What can we help you with this week?": null,
//             "Last name": "DelliBovi",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1683849600000,
//             "email": "stephen.dellibovi@fhfg.com",
//             "sum": 25
//         },
//         {
//             "First name": "Richard",
//             "How many new contacts did you have this week?": 18,
//             "What can we help you with this week?": null,
//             "Last name": "Piazza",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1683849600000,
//             "email": "richard.piazza@fhfg.com",
//             "sum": 25
//         },
//         {
//             "First name": "Evelyn",
//             "How many new contacts did you have this week?": 16,
//             "What can we help you with this week?": null,
//             "Last name": "Gellar",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1683763200000,
//             "email": "Evelyn.Gellar@fhfg.com",
//             "sum": 35
//         },
//         {
//             "First name": "Kristen",
//             "How many new contacts did you have this week?": 20,
//             "What can we help you with this week?": null,
//             "Last name": "LaMarca",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 6,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1683763200000,
//             "email": "kristen.lamarca@fhfg.com",
//             "sum": 50
//         },
//         {
//             "First name": "Stephen ",
//             "How many new contacts did you have this week?": 7,
//             "What can we help you with this week?": null,
//             "Last name": "DelliBovi",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 1,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1683244800000,
//             "email": "stephen.dellibovi@fhfg.com",
//             "sum": 17
//         },
//         {
//             "First name": "John",
//             "How many new contacts did you have this week?": 27,
//             "What can we help you with this week?": null,
//             "Last name": "Wool",
//             "How many introductions did you receive this week?": 0,
//             "How many case opens did you have this week?": 1,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1683244800000,
//             "email": "john.wool@fhfg.com",
//             "sum": 15
//         },
//         {
//             "First name": "Richard",
//             "How many new contacts did you have this week?": 11,
//             "What can we help you with this week?": null,
//             "Last name": "Piazza",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 1,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1683244800000,
//             "email": "richard.piazza@fhfg.com",
//             "sum": 20
//         },
//         {
//             "First name": "Evelyn",
//             "How many new contacts did you have this week?": 6,
//             "What can we help you with this week?": null,
//             "Last name": "Gellar",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1683158400000,
//             "email": "Evelyn.Gellar@fhfg.com",
//             "sum": 16
//         },
//         {
//             "First name": "Kristen",
//             "How many new contacts did you have this week?": 15,
//             "What can we help you with this week?": null,
//             "Last name": "LaMarca",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 5,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1683158400000,
//             "email": "kristen.lamarca@fhfg.com",
//             "sum": 40
//         },
//         {
//             "First name": "John",
//             "How many new contacts did you have this week?": 41,
//             "What can we help you with this week?": null,
//             "Last name": "Wool",
//             "How many introductions did you receive this week?": 7,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1682640000000,
//             "email": "john.wool@fhfg.com",
//             "sum": 35
//         },
//         {
//             "First name": "Stephen",
//             "How many new contacts did you have this week?": 14,
//             "What can we help you with this week?": null,
//             "Last name": "DelliBovi",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1682640000000,
//             "email": "stephen.dellibovi@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "Evelyn",
//             "How many new contacts did you have this week?": 17,
//             "What can we help you with this week?": null,
//             "Last name": "Gellar",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1682640000000,
//             "email": "Evelyn.Gellar@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "Richard",
//             "How many new contacts did you have this week?": 12,
//             "What can we help you with this week?": null,
//             "Last name": "Piazza",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1682553600000,
//             "email": "richard.piazza@fhfg.com",
//             "sum": 35
//         },
//         {
//             "First name": "Kristen",
//             "How many new contacts did you have this week?": 22,
//             "What can we help you with this week?": null,
//             "Last name": "LaMarca",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 5,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1682553600000,
//             "email": "kristen.lamarca@fhfg.com",
//             "sum": 40
//         },
//         {
//             "First name": "John",
//             "How many new contacts did you have this week?": 33,
//             "What can we help you with this week?": null,
//             "Last name": "Wool",
//             "How many introductions did you receive this week?": 6,
//             "How many case opens did you have this week?": 4,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1682035200000,
//             "email": "john.wool@fhfg.com",
//             "sum": 35
//         },
//         {
//             "First name": "Richard",
//             "How many new contacts did you have this week?": 18,
//             "What can we help you with this week?": null,
//             "Last name": "Piazza",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1681948800000,
//             "email": "richard.piazza@fhfg.com",
//             "sum": 35
//         },
//         {
//             "First name": "Stephen ",
//             "How many new contacts did you have this week?": 11,
//             "What can we help you with this week?": null,
//             "Last name": "DelliBovi",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1681948800000,
//             "email": "stephen.dellibovi@fhfg.com",
//             "sum": 35
//         },
//         {
//             "First name": "Evelyn",
//             "How many new contacts did you have this week?": 11,
//             "What can we help you with this week?": null,
//             "Last name": "Gellar",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 5,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1681948800000,
//             "email": "Evelyn.Gellar@fhfg.com",
//             "sum": 35
//         },
//         {
//             "First name": "Kristen",
//             "How many new contacts did you have this week?": 10,
//             "What can we help you with this week?": null,
//             "Last name": "LaMarca",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 5,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1681948800000,
//             "email": "kristen.lamarca@fhfg.com",
//             "sum": 40
//         },
//         {
//             "First name": "John",
//             "How many new contacts did you have this week?": 22,
//             "What can we help you with this week?": null,
//             "Last name": "Wool",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 4,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1681430400000,
//             "email": "john.wool@fhfg.com",
//             "sum": 40
//         },
//         {
//             "First name": "Stephen",
//             "How many new contacts did you have this week?": 11,
//             "What can we help you with this week?": null,
//             "Last name": "DelliBovi",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1681430400000,
//             "email": "stephen.dellibovi@fhfg.com",
//             "sum": 25
//         },
//         {
//             "First name": "Evelyn",
//             "How many new contacts did you have this week?": 13,
//             "What can we help you with this week?": null,
//             "Last name": "Gellar",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1681344000000,
//             "email": "Evelyn.Gellar@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "Richard",
//             "How many new contacts did you have this week?": 0,
//             "What can we help you with this week?": null,
//             "Last name": "Piazza",
//             "How many introductions did you receive this week?": 0,
//             "How many case opens did you have this week?": 0,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1681344000000,
//             "email": "richard.piazza@fhfg.com",
//             "sum": 0
//         },
//         {
//             "First name": "Kristen",
//             "How many new contacts did you have this week?": 22,
//             "What can we help you with this week?": null,
//             "Last name": "LaMarca",
//             "How many introductions did you receive this week?": 6,
//             "How many case opens did you have this week?": 7,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1681344000000,
//             "email": "kristen.lamarca@fhfg.com",
//             "sum": 55
//         },
//         {
//             "First name": "Stephen ",
//             "How many new contacts did you have this week?": 11,
//             "What can we help you with this week?": null,
//             "Last name": "DelliBovi",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1680825600000,
//             "email": "stephen.dellibovi@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "John",
//             "How many new contacts did you have this week?": 26,
//             "What can we help you with this week?": null,
//             "Last name": "Wool",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 5,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1680825600000,
//             "email": "john.wool@fhfg.com",
//             "sum": 45
//         },
//         {
//             "First name": "Evelyn",
//             "How many new contacts did you have this week?": 4,
//             "What can we help you with this week?": null,
//             "Last name": "Gellar",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1680825600000,
//             "email": "Evelyn.Gellar@fhfg.com",
//             "sum": 24
//         },
//         {
//             "First name": "Richard",
//             "How many new contacts did you have this week?": 19,
//             "What can we help you with this week?": null,
//             "Last name": "Piazza",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 6,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1680739200000,
//             "email": "richard.piazza@fhfg.com",
//             "sum": 50
//         },
//         {
//             "First name": "Kristen",
//             "How many new contacts did you have this week?": 12,
//             "What can we help you with this week?": null,
//             "Last name": "LaMarca",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 5,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1680739200000,
//             "email": "kristen.lamarca@fhfg.com",
//             "sum": 40
//         },
//         {
//             "First name": "Stephen ",
//             "How many new contacts did you have this week?": 14,
//             "What can we help you with this week?": null,
//             "Last name": "DelliBovi",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1680220800000,
//             "email": "stephen.dellibovi@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "John",
//             "How many new contacts did you have this week?": 33,
//             "What can we help you with this week?": null,
//             "Last name": "Wool",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 5,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1680220800000,
//             "email": "john.wool@fhfg.com",
//             "sum": 40
//         },
//         {
//             "First name": "Richard",
//             "How many new contacts did you have this week?": 16,
//             "What can we help you with this week?": null,
//             "Last name": "Piazza",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 4,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1680220800000,
//             "email": "richard.piazza@fhfg.com",
//             "sum": 40
//         },
//         {
//             "First name": "Evelyn",
//             "How many new contacts did you have this week?": 9,
//             "What can we help you with this week?": null,
//             "Last name": "Gellar",
//             "How many introductions did you receive this week?": 0,
//             "How many case opens did you have this week?": 4,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1680134400000,
//             "email": "evelyn.gellar@fhfg.com",
//             "sum": 29
//         },
//         {
//             "First name": "Kristen",
//             "How many new contacts did you have this week?": 15,
//             "What can we help you with this week?": null,
//             "Last name": "LaMarca",
//             "How many introductions did you receive this week?": 6,
//             "How many case opens did you have this week?": 8,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1680134400000,
//             "email": "kristen.lamarca@fhfg.com",
//             "sum": 55
//         },
//         {
//             "First name": "Evelyn",
//             "How many new contacts did you have this week?": 37,
//             "What can we help you with this week?": null,
//             "Last name": "Gellar",
//             "How many introductions did you receive this week?": 6,
//             "How many case opens did you have this week?": 9,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1679616000000,
//             "email": "Evelyn.Gellar@fhfg.com",
//             "sum": 65
//         },
//         {
//             "First name": "Stephen ",
//             "How many new contacts did you have this week?": 22,
//             "What can we help you with this week?": null,
//             "Last name": "DelliBovi",
//             "How many introductions did you receive this week?": 1,
//             "How many case opens did you have this week?": 1,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1679616000000,
//             "email": "stephen.dellibovi@fhfg.com",
//             "sum": 20
//         },
//         {
//             "First name": "John ",
//             "How many new contacts did you have this week?": 18,
//             "What can we help you with this week?": null,
//             "Last name": "Wool",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1679616000000,
//             "email": "john.wool@fhfg.com",
//             "sum": 35
//         },
//         {
//             "First name": "Richard",
//             "How many new contacts did you have this week?": 4,
//             "What can we help you with this week?": null,
//             "Last name": "Piazza",
//             "How many introductions did you receive this week?": 0,
//             "How many case opens did you have this week?": 0,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1679616000000,
//             "email": "richard.piazza@fhfg.com",
//             "sum": 4
//         },
//         {
//             "First name": "Kristen",
//             "How many new contacts did you have this week?": 12,
//             "What can we help you with this week?": null,
//             "Last name": "LaMarca",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 7,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1679529600000,
//             "email": "kristen.lamarca@fhfg.com",
//             "sum": 50
//         },
//         {
//             "First name": "Evelyn",
//             "How many new contacts did you have this week?": 6,
//             "What can we help you with this week?": null,
//             "Last name": "Gellar",
//             "How many introductions did you receive this week?": 1,
//             "How many case opens did you have this week?": 4,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1679011200000,
//             "email": "Evelyn.Gellar@fhfg.com",
//             "sum": 31
//         },
//         {
//             "First name": "Richard",
//             "How many new contacts did you have this week?": 23,
//             "What can we help you with this week?": null,
//             "Last name": "Piazza",
//             "How many introductions did you receive this week?": 6,
//             "How many case opens did you have this week?": 4,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1678924800000,
//             "email": "richard.piazza@fhfg.com",
//             "sum": 40
//         },
//         {
//             "First name": "John",
//             "How many new contacts did you have this week?": 37,
//             "What can we help you with this week?": null,
//             "Last name": "Wool",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1678924800000,
//             "email": "john.wool@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "Stephen ",
//             "How many new contacts did you have this week?": 14,
//             "What can we help you with this week?": null,
//             "Last name": "DelliBovi",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1678924800000,
//             "email": "stpehen.dellibovi@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "Kristen",
//             "How many new contacts did you have this week?": 20,
//             "What can we help you with this week?": null,
//             "Last name": "LaMarca",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 4,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1678924800000,
//             "email": "kristen.lamarca@fhfg.com",
//             "sum": 40
//         },
//         {
//             "First name": "Evelyn",
//             "How many new contacts did you have this week?": 20,
//             "What can we help you with this week?": null,
//             "Last name": "Gellar",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1678406400000,
//             "email": "Evelyn.Gellar@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "John",
//             "How many new contacts did you have this week?": 36,
//             "What can we help you with this week?": null,
//             "Last name": "Wool",
//             "How many introductions did you receive this week?": 6,
//             "How many case opens did you have this week?": 4,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1678406400000,
//             "email": "john.wool@fhfg.com",
//             "sum": 40
//         },
//         {
//             "First name": "Stephen",
//             "How many new contacts did you have this week?": 13,
//             "What can we help you with this week?": null,
//             "Last name": "DelliBovi",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1678406400000,
//             "email": "stephen.dellibovi@fhfg.com",
//             "sum": 25
//         },
//         {
//             "First name": "Richard",
//             "How many new contacts did you have this week?": 14,
//             "What can we help you with this week?": null,
//             "Last name": "Piazza",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1678320000000,
//             "email": "richard.piazza@fhfg.com",
//             "sum": 35
//         },
//         {
//             "First name": "Kristen",
//             "How many new contacts did you have this week?": 21,
//             "What can we help you with this week?": null,
//             "Last name": "LaMarca",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 5,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1678320000000,
//             "email": "kristen.lamarca@fhfg.com",
//             "sum": 40
//         },
//         {
//             "First name": "John",
//             "How many new contacts did you have this week?": 18,
//             "What can we help you with this week?": null,
//             "Last name": "Wool",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1677801600000,
//             "email": "john.wool@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "Stephen ",
//             "How many new contacts did you have this week?": 13,
//             "What can we help you with this week?": null,
//             "Last name": "DelliBovi",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1677801600000,
//             "email": "stephen.dellibovi@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "Richard",
//             "How many new contacts did you have this week?": 7,
//             "What can we help you with this week?": null,
//             "Last name": "Piazza",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1677801600000,
//             "email": "richard.piazza@fhfg.com",
//             "sum": 22
//         },
//         {
//             "First name": "Evelyn",
//             "How many new contacts did you have this week?": 8,
//             "What can we help you with this week?": null,
//             "Last name": "Gellar",
//             "How many introductions did you receive this week?": 0,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1677715200000,
//             "email": "Evelyn.Gellar@fhfg.com",
//             "sum": 28
//         },
//         {
//             "First name": "Kristen",
//             "How many new contacts did you have this week?": 15,
//             "What can we help you with this week?": null,
//             "Last name": "LaMarca",
//             "How many introductions did you receive this week?": 6,
//             "How many case opens did you have this week?": 9,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1677715200000,
//             "email": "kristen.lamarca@fhfg.com",
//             "sum": 60
//         },
//         {
//             "First name": "John",
//             "How many new contacts did you have this week?": 22,
//             "What can we help you with this week?": null,
//             "Last name": "Wool",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 4,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1677196800000,
//             "email": "john.wool@fhfg.com",
//             "sum": 40
//         },
//         {
//             "First name": "Stephen",
//             "How many new contacts did you have this week?": 17,
//             "What can we help you with this week?": null,
//             "Last name": "DelliBovi",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1677196800000,
//             "email": "stephen.dellibovi@fhfg.com",
//             "sum": 25
//         },
//         {
//             "First name": "Richard",
//             "How many new contacts did you have this week?": 19,
//             "What can we help you with this week?": null,
//             "Last name": "Piazza",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1677196800000,
//             "email": "richard.piazza@fhfg.com",
//             "sum": 25
//         },
//         {
//             "First name": "Kristen",
//             "How many new contacts did you have this week?": 5,
//             "What can we help you with this week?": null,
//             "Last name": "LaMarca",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 5,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1677110400000,
//             "email": "kristen.lamarca@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "Richard",
//             "How many new contacts did you have this week?": 21,
//             "What can we help you with this week?": null,
//             "Last name": "Piazza",
//             "How many introductions did you receive this week?": 6,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1676505600000,
//             "email": "richard.piazza@fhfg.com",
//             "sum": 35
//         },
//         {
//             "First name": "Stephen ",
//             "How many new contacts did you have this week?": 16,
//             "What can we help you with this week?": null,
//             "Last name": "DelliBovi",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1676505600000,
//             "email": "stephen.dellibovi@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "john",
//             "How many new contacts did you have this week?": 24,
//             "What can we help you with this week?": null,
//             "Last name": "Wool",
//             "How many introductions did you receive this week?": 6,
//             "How many case opens did you have this week?": 5,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1676505600000,
//             "email": "john.wool@fhfg.com",
//             "sum": 45
//         },
//         {
//             "First name": "Evelyn",
//             "How many new contacts did you have this week?": 6,
//             "What can we help you with this week?": null,
//             "Last name": "Gellar",
//             "How many introductions did you receive this week?": 0,
//             "How many case opens did you have this week?": 5,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1676505600000,
//             "email": "Evelyn.Gellar@fhfg.com",
//             "sum": 31
//         },
//         {
//             "First name": "Kristen",
//             "How many new contacts did you have this week?": 12,
//             "What can we help you with this week?": null,
//             "Last name": "LaMarca",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 5,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1676505600000,
//             "email": "kristen.lamarca@fhfg.com",
//             "sum": 40
//         },
//         {
//             "First name": "Stephen ",
//             "How many new contacts did you have this week?": 11,
//             "What can we help you with this week?": null,
//             "Last name": "DelliBovi",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1675987200000,
//             "email": "stephen.dellibovi@fhfg.com",
//             "sum": 25
//         },
//         {
//             "First name": "Evelyn",
//             "How many new contacts did you have this week?": 11,
//             "What can we help you with this week?": null,
//             "Last name": "Gellar",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 4,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1675987200000,
//             "email": "Evelyn.Gellar@fhfg.com",
//             "sum": 35
//         },
//         {
//             "First name": "Richard",
//             "How many new contacts did you have this week?": 9,
//             "What can we help you with this week?": null,
//             "Last name": "Piazza",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1675987200000,
//             "email": "richard.piazza@fhfg.com",
//             "sum": 29
//         },
//         {
//             "First name": "John",
//             "How many new contacts did you have this week?": 31,
//             "What can we help you with this week?": null,
//             "Last name": "Wool",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 6,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1675987200000,
//             "email": "john.wool@fhfg.com",
//             "sum": 50
//         },
//         {
//             "First name": "Kristen",
//             "How many new contacts did you have this week?": 6,
//             "What can we help you with this week?": null,
//             "Last name": "LaMarca",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 4,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1675900800000,
//             "email": "kristen.lamarca@fhfg.com",
//             "sum": 31
//         },
//         {
//             "First name": "Stephen",
//             "How many new contacts did you have this week?": 16,
//             "What can we help you with this week?": null,
//             "Last name": "DelliBovi",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1675382400000,
//             "email": "stephen.dellibovi@fhfg.com",
//             "sum": 25
//         },
//         {
//             "First name": "Evelyn",
//             "How many new contacts did you have this week?": 4,
//             "What can we help you with this week?": null,
//             "Last name": "Gellar",
//             "How many introductions did you receive this week?": 0,
//             "How many case opens did you have this week?": 4,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1675382400000,
//             "email": "evelyn.gellar@gmail.com",
//             "sum": 29
//         },
//         {
//             "First name": "Richard",
//             "How many new contacts did you have this week?": 18,
//             "What can we help you with this week?": null,
//             "Last name": "Piazza",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1675296000000,
//             "email": "richard.piazza@fhfg.com",
//             "sum": 25
//         },
//         {
//             "First name": "Kristen",
//             "How many new contacts did you have this week?": 6,
//             "What can we help you with this week?": null,
//             "Last name": "LaMarca",
//             "How many introductions did you receive this week?": 0,
//             "How many case opens did you have this week?": 6,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1675296000000,
//             "email": "kristen.lamarca@fhfg.com",
//             "sum": 36
//         },
//         {
//             "First name": "John ",
//             "How many new contacts did you have this week?": 27,
//             "What can we help you with this week?": null,
//             "Last name": "Wool ",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 4,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1675296000000,
//             "email": "john.wool@fhfg.com",
//             "sum": 40
//         },
//         {
//             "First name": "Stephen ",
//             "How many new contacts did you have this week?": 14,
//             "What can we help you with this week?": null,
//             "Last name": "DelliBovi",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 2,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1674777600000,
//             "email": "stephen.dellibovi@fhfg.com",
//             "sum": 25
//         },
//         {
//             "First name": "John ",
//             "How many new contacts did you have this week?": 36,
//             "What can we help you with this week?": null,
//             "Last name": "Wool",
//             "How many introductions did you receive this week?": 7,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1674691200000,
//             "email": "john.wool@fhfg.com",
//             "sum": 35
//         },
//         {
//             "First name": "Evelyn",
//             "How many new contacts did you have this week?": 30,
//             "What can we help you with this week?": null,
//             "Last name": "Gellar",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 4,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1674691200000,
//             "email": "Evelyn.Gellar@fhfg.com",
//             "sum": 35
//         },
//         {
//             "First name": "Richard",
//             "How many new contacts did you have this week?": 18,
//             "What can we help you with this week?": null,
//             "Last name": "Piazza",
//             "How many introductions did you receive this week?": 4,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1674691200000,
//             "email": "richard.piazza@fhfg.com",
//             "sum": 35
//         },
//         {
//             "First name": "Kristen",
//             "How many new contacts did you have this week?": 7,
//             "What can we help you with this week?": null,
//             "Last name": "LaMarca",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 4,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1674691200000,
//             "email": "kristen.lamarca@fhfg.com",
//             "sum": 27
//         },
//         {
//             "First name": "Max",
//             "How many new contacts did you have this week?": 3,
//             "What can we help you with this week?": null,
//             "Last name": "McKinney",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1674691200000,
//             "email": "max.mckinney@fhfg.com",
//             "sum": 23
//         },
//         {
//             "First name": "Kristen",
//             "How many new contacts did you have this week?": 6,
//             "What can we help you with this week?": null,
//             "Last name": "LaMarca",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 1,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1674172800000,
//             "email": "kristen.lamarca@fhfg.com",
//             "sum": 16
//         },
//         {
//             "First name": "Evelyn",
//             "How many new contacts did you have this week?": 13,
//             "What can we help you with this week?": null,
//             "Last name": "Gellar",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1674172800000,
//             "email": "Evelyn.Gellar@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "John",
//             "How many new contacts did you have this week?": 22,
//             "What can we help you with this week?": null,
//             "Last name": "Wool",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 4,
//             "How many COI meetings did you have this week?": 0,
//             "Submitted At": 1674172800000,
//             "email": "john.wool@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "Stephen",
//             "How many new contacts did you have this week?": 11,
//             "What can we help you with this week?": null,
//             "Last name": "DelliBovi",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 1,
//             "How many COI meetings did you have this week?": 2,
//             "Submitted At": 1674086400000,
//             "email": "stephen.dellibovi@fhfg.com",
//             "sum": 20
//         },
//         {
//             "First name": "Evelyn",
//             "How many new contacts did you have this week?": 13,
//             "What can we help you with this week?": null,
//             "Last name": "Gellar",
//             "How many introductions did you receive this week?": 2,
//             "How many case opens did you have this week?": 3,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1674086400000,
//             "email": "Evelyn.Gellar@fhfg.com",
//             "sum": 30
//         },
//         {
//             "First name": "Richard",
//             "How many new contacts did you have this week?": 9,
//             "What can we help you with this week?": null,
//             "Last name": "Piazza",
//             "How many introductions did you receive this week?": 5,
//             "How many case opens did you have this week?": 1,
//             "How many COI meetings did you have this week?": 3,
//             "Submitted At": 1674086400000,
//             "email": "Richard.Piazza@fhfg.com",
//             "sum": 24
//         },
//         {
//             "First name": "Kristen",
//             "How many new contacts did you have this week?": 6,
//             "What can we help you with this week?": null,
//             "Last name": "LaMarca",
//             "How many introductions did you receive this week?": 3,
//             "How many case opens did you have this week?": 1,
//             "How many COI meetings did you have this week?": 1,
//             "Submitted At": 1674086400000,
//             "email": "kristen.lamarca@fhfg.com",
//             "sum": 16
//         }
//     ]
// }